import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import InternationalTransferFooterButtons from "./InternationalTransferFooterButtons";
import GreyCircleIcon from "../../../../images/grey-circle.svg";
import GreenCircleIcon from "../../../../images/green-circle.svg";
import GreenCircleEmptyIcon from "../../../../images/green-circle-empty.svg";
import GreyRectVerticalIcon from "../../../../images/grey-rect-vertical.svg";
import GreenRectVerticalIcon from "../../../../images/green-rect-vertical.svg";

function InternationalTransferTrack({transactionStatus, handleReturn, isCancellable, handleCancel,handleAmend, intlTransfer}) {

    console.log("InternationalTransferTrack========", transactionStatus);
    console.log("intlTransfer========", intlTransfer);

    const statusObj = {
        ERROR: {
            header: "Error",
            dot1: GreyCircleIcon,
            dot2: GreyCircleIcon,
            dot3: GreyCircleIcon,
            line1: GreyRectVerticalIcon,
            line2: GreyRectVerticalIcon,
            text1: "Cash",
            subtext: "",
            text2: "Recipient",
        },
        UNCOMMITTED: {
            header: "Not Found",
            dot1: GreyCircleIcon,
            dot2: GreyCircleIcon,
            dot3: GreyCircleIcon,
            line1: GreyRectVerticalIcon,
            line2: GreyRectVerticalIcon,
            text1: "Cash",
            subtext: "Waiting to be processed",
            text2: "Recipient",
        },
        PRCSS: {
            header: "In Progress",
            dot1: GreenCircleIcon,
            dot2: GreenCircleEmptyIcon,
            dot3: GreenCircleEmptyIcon,
            line1: GreenRectVerticalIcon,
            line2: GreyRectVerticalIcon,
            text1: "Cash",
            subtext: "",
            text2: "Recipient",
        },
        HOLD: {
            header: "In Progress",
            dot1: GreenCircleIcon,
            dot2: GreenCircleEmptyIcon,
            dot3: GreenCircleEmptyIcon,
            line1: GreenRectVerticalIcon,
            line2: GreyRectVerticalIcon,
            text1: "Cash",
            subtext: "This transaction is currently on hold.",
            text2: "Recipient",
        },
        AVAIL: {
            header: "In Progress",
            dot1: GreenCircleIcon,
            dot2: GreenCircleEmptyIcon,
            dot3: GreyCircleIcon,
            line1: GreenRectVerticalIcon,
            line2: GreyRectVerticalIcon,
            text1: "",
            subtext: "Ready - Transfer is waiting for pickup",
            text2: "Recipient",
        },
        CANCL: {
            header: "Cancelled",
            dot1: GreyCircleIcon,
            dot2: GreyCircleIcon,
            dot3: GreyCircleIcon,
            line1: GreyRectVerticalIcon,
            line2: GreyRectVerticalIcon,
            text1: "Cash",
            subtext: "",
            text2: "Recipient",
        },
        RECVD: {
            header: "Received",
            dot1: GreenCircleIcon,
            dot2: GreenCircleIcon,
            dot3: GreenCircleIcon,
            line1: GreenRectVerticalIcon,
            line2: GreenRectVerticalIcon,
            text1: "Cash",
            subtext: "",
            text2: "Recipient",
        },
        REFND: {
            header: "Refunded",
            dot1: GreenCircleIcon,
            dot2: GreenCircleEmptyIcon,
            dot3: GreenCircleIcon,
            line1: GreenRectVerticalIcon,
            line2: GreyRectVerticalIcon,
            text1: "Cash",
            subtext: "",
            text2: "Refunded",
        },
        ApprovalPending: {
            header: "Approval Pending",
            dot1: GreenCircleIcon,
            dot2: GreenCircleEmptyIcon,
            dot3: GreenCircleEmptyIcon,
            line1: GreenRectVerticalIcon,
            line2: GreyRectVerticalIcon,
            text1: "Cash",
            subtext: "",
            text2: "Recipient",
        },
        AFR: {
            header: "In Progress",
            dot1: GreenCircleIcon,
            dot2: GreenCircleEmptyIcon,
            dot3: GreyCircleIcon,
            line1: GreenRectVerticalIcon,
            line2: GreyRectVerticalIcon,
            text1: "",
            subtext: intlTransfer == "Moneygram" ? "Available For Refund - Contact Moneygram" : "Available For Refund",
            text2: "Recipient",
        }
    };


    return (
        <Box sx={{
            maxHeight: "600px",
            marginTop: "10px"
        }}>
            <Box
                sx={{
                    maxWidth: 400,
                    margin: "100px auto",
                }}
            >
                <Typography
                    id="status-modal"
                    sx={{ color: "green", fontWeight: "bold",  }}
                >
                    {statusObj[transactionStatus]?.header}
                </Typography>

                <Grid container alignItems="center" spacing={2} >
                    <Grid item>
                        <img src={statusObj[transactionStatus]?.dot1} alt="Dot 1" style={{ height: "28px", width: "28px" }} loading="lazy"/>
                    </Grid>
                </Grid>

                <Box sx={{ position: "relative", left: "3%" }}>
                    <img src={statusObj[transactionStatus]?.line1} alt="Line 1" loading="lazy" style={{ top: "10%" }}/>
                </Box>

                <Grid container alignItems="center" spacing={1} sx={{ padding: "0px" }}>
                    <Grid item>
                        <img src={statusObj[transactionStatus]?.dot2} alt="Dot 2" loading="lazy"  style={{ height: "28px", width: "28px" }}/>
                    </Grid>
                    <Grid item>
                        <Box>
                            <Typography
                                sx={{ color: "green", fontWeight: "bold",  }}
                            >
                                {statusObj[transactionStatus]?.text1}
                            </Typography>
                            {statusObj[transactionStatus]?.subtext && (
                                <Typography
                                    variant="body2"
                                    sx={{ color: "green", fontWeight: "bold" }}
                                >
                                    {statusObj[transactionStatus]?.subtext}
                                </Typography>
                            )}
                        </Box>
                    </Grid>
                </Grid>

                <Box sx={{ position: "relative", left: "3%" }}>
                    <img src={statusObj[transactionStatus]?.line2} alt="Line 2" style={{ position: "relative", }} loading="lazy"/>
                </Box>

                <Grid container alignItems="center" spacing={2} sx={{ position: "relative", bottom: "8px" }}>
                    <Grid item>
                        <img src={statusObj[transactionStatus]?.dot3} alt="Dot 3" style={{ height: "28px", width: "28px" }} loading="lazy" />
                    </Grid>
                    <Grid item>
                        <Typography sx={{ color: "green", fontWeight: "bold" }}>
                            {statusObj[transactionStatus]?.text2}
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
            <Box className="buttonContainer">
            <InternationalTransferFooterButtons
                handleButtonOne={handleReturn}
                buttonOneText="Back"
                showButtonOne={true}
                showButtonTwo={transactionStatus === "AVAIL"}
                buttonTwoText={transactionStatus === "AVAIL" ? "Amend Name" : ""}
                handleButtonTwo={handleAmend}
                showMiddleButton={isCancellable && transactionStatus === "AVAIL"}
                middleButtonText={isCancellable && transactionStatus === "AVAIL" ? "Cancel Transaction" : ""}
                handleMiddleButton={handleCancel}
            />
            </Box>
        </Box>
    )
}

export default InternationalTransferTrack;


// const statusObj = {
//     ERROR: {
//         header: "Error",
//         dot1: GreyCircleIcon,
//         dot2: GreyCircleIcon,
//         dot3: GreyCircleIcon,
//         line1: GreyRectVerticalIcon,
//         line2: GreyRectVerticalIcon,
//         text1: "Cash",
//         subtext: "",
//         text2: "Recipient",
//     },
//     UNCOMMITTED: {
//         header: "Not Found",
//         dot1: GreyCircleIcon,
//         dot2: GreyCircleIcon,
//         dot3: GreyCircleIcon,
//         line1: GreyRectVerticalIcon,
//         line2: GreyRectVerticalIcon,
//         text1: "Cash",
//         subtext: "Waiting to be processed",
//         text2: "Recipient",
//     },
//     PRCSS: {
//         header: "In Progress",
//         dot1: GreenCircleIcon,
//         dot2: GreenCircleEmptyIcon,
//         dot3: GreenCircleEmptyIcon,
//         line1: GreenRectVerticalIcon,
//         line2: GreyRectVerticalIcon,
//         text1: "Cash",
//         subtext: "",
//         text2: "Recipient",
//     },
//     HOLD: {
//         header: "In Progress",
//         dot1: GreenCircleIcon,
//         dot2: GreenCircleEmptyIcon,
//         dot3: GreenCircleEmptyIcon,
//         line1: GreenRectVerticalIcon,
//         line2: GreyRectVerticalIcon,
//         text1: "Cash",
//         subtext: "This transaction is currently on hold.",
//         text2: "Recipient",
//     },
//     AVAIL: {
//         header: "In Progress",
//         dot1: GreenCircleIcon,
//         dot2: GreenCircleEmptyIcon,
//         dot3: GreyCircleIcon,
//         line1: GreenRectVerticalIcon,
//         line2: GreyRectVerticalIcon,
//         text1: "",
//         subtext: "Ready - Transfer is waiting for pickup",
//         text2: "Recipient",
//     },
//     CANCL: {
//         header: "Cancelled",
//         dot1: GreyCircleIcon,
//         dot2: GreyCircleIcon,
//         dot3: GreyCircleIcon,
//         line1: GreyRectVerticalIcon,
//         line2: GreyRectVerticalIcon,
//         text1: "Cash",
//         subtext: "",
//         text2: "Recipient",
//     },
//     RECVD: {
//         header: "Received",
//         dot1: GreenCircleIcon,
//         dot2: GreenCircleIcon,
//         dot3: GreenCircleIcon,
//         line1: GreenRectVerticalIcon,
//         line2: GreenRectVerticalIcon,
//         text1: "Cash",
//         subtext: "",
//         text2: "Recipient",
//     },
//     REFND: {
//         header: "Refunded",
//         dot1: GreenCircleIcon,
//         dot2: GreenCircleEmptyIcon,
//         dot3: GreenCircleIcon,
//         line1: GreenRectVerticalIcon,
//         line2: GreyRectVerticalIcon,
//         text1: "Cash",
//         subtext: "",
//         text2: "Refunded",
//     },
//     ApprovalPending: {
//         header: "Approval Pending",
//         dot1: GreenCircleIcon,
//         dot2: GreenCircleEmptyIcon,
//         dot3: GreenCircleEmptyIcon,
//         line1: GreenRectVerticalIcon,
//         line2: GreyRectVerticalIcon,
//         text1: "Cash",
//         subtext: "",
//         text2: "Recipient",
//     },
//     AFR: {
//         header: "In Progress",
//         dot1: GreenCircleIcon,
//         dot2: GreenCircleEmptyIcon,
//         dot3: GreyCircleIcon,
//         line1: GreenRectVerticalIcon,
//         line2: GreyRectVerticalIcon,
//         text1: "",
//         subtext: intlTransfer == "Moneygram" ? "Available For Refund" : "Available For Refund",
//         text2: "Recipient",
//     }
// };